import { AppState } from '../../helpers/store/AppState';

const selectLayout = (state: AppState) => state.layout;

export const selectSidebarShow = (state: AppState) => selectLayout(state).sidebarShow;
